<div class="kontakt-search-container">
  <form [formGroup]="kontaktSearch">
    <pezi-text #filter [formGroup]="kontaktSearch" formControlName="search" label="Kontakte suchen"
               leadingIcon="search"></pezi-text>
  </form>
  <div class="results-box">
    <ng-container *ngIf="!kontakteLoading">
      <div class="placeholder-box" *ngIf="!filteredKontakte || filteredKontakte.length === 0">
        <app-no-data message="{{alreadySearchedOnce ? 'Keine Kontakte gefunden' : 'Suchergebnisse'}}"
                     [icon]="'contacts'" [withShadow]="false"></app-no-data>
      </div>
      <cdk-virtual-scroll-viewport itemSize="50" class="v-scrollbox"
                                   *ngIf="filteredKontakte && filteredKontakte.length > 0">
        <div class="kontakt-box"
             *cdkVirtualFor="let kontakt of filteredKontakte; let i = index" (click)="selectContact(kontakt)">
          <div class="left">
            <div matListItemIcon class="image-list-icon" *ngIf="kontakt.imageURL" [ngStyle]="{
              'background-image': 'url(' + kontakt.imageURL + '), url('+kontakt.fallbackURL+')'
            }"></div>
            <div matListItemIcon class="image-list-icon" *ngIf="!kontakt.imageURL && kontakt.fallbackURL" [ngStyle]="{
              'background-image': 'url(' + kontakt.fallbackURL + ')'
            }"></div>
          </div>
          <div class="right">
            <h5 class="main">{{ kontakt.text }}</h5>
            <h5 class="sub">{{ kontakt.subtext ? kontakt.subtext : '-' }}</h5>
            <div class="additional">{{ kontakt.data.abteilung ? kontakt.data.abteilung : '-' }}</div>
          </div>

        </div>
      </cdk-virtual-scroll-viewport>
    </ng-container>
    <div *ngIf="kontakteLoading" class="loading-container">
      <app-loader></app-loader>
    </div>
  </div>
  <pezi-button text="Kontaktübersicht" [isSecondary]="true" [alignIconRight]="true" (click)="openContactSearch()"
               [disabled]="!originalKontakte" [fullWidth]="true"></pezi-button>
</div>
